import React from "react";
import FileUpload from "@/components/FileUpload";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const EMPTY_COURSE = {
  title: "", short_description: "", full_description: "", category_id: "", price: "", discount_price: "",
  course_type: "recorded", level: "beginner", language: "English", validity_days: "365",
  start_date: "", end_date: "", thumbnail: "",
  what_you_learn: [], highlights: [], requirements: [], faqs: [],
};

function Pick({ label, value, onChange, options, testid }) {
  return (
    <div>
      <Label>{label}</Label>
      <Select value={value ? String(value) : undefined} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Select" /></SelectTrigger>
        <SelectContent>{options.map(([v, l]) => <SelectItem key={v} value={String(v)}>{l}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}

function Field({ label, children }) {
  return <div><Label>{label}</Label>{children}</div>;
}

export function CourseForm({ f, set, cats }) {
  const inp = (k, props = {}) => <Input value={f[k] ?? ""} onChange={(e) => set(k, e.target.value)} data-testid={`cf-${k}`} {...props} />;
  return (
    <div className="space-y-4" data-testid="course-form">
      <Field label="Course Title *">{inp("title")}</Field>
      <Field label="Short Description"><Textarea rows={2} value={f.short_description || ""} onChange={(e) => set("short_description", e.target.value)} data-testid="cf-short_description" /></Field>
      <Field label="Full Description"><Textarea rows={5} value={f.full_description || ""} onChange={(e) => set("full_description", e.target.value)} data-testid="cf-full_description" /></Field>
      <div className="rounded-lg border border-border p-3 space-y-2">
        <Label>Thumbnail</Label>
        <FileUpload accept="image/*" preview value={f.thumbnail || ""} onChange={(url) => set("thumbnail", url)} testid="thumb-upload" />
        {inp("thumbnail", { placeholder: "or paste image URL" })}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <Pick label="Category" value={f.category_id} onChange={(v) => set("category_id", v)} options={cats.map((c) => [c.id, c.name])} testid="cf-category" />
          {cats.length === 0 && <p className="text-xs text-muted-foreground mt-1" data-testid="cf-no-categories">No categories yet — an admin can add them in Admin → Categories.</p>}
        </div>
        <Pick label="Type" value={f.course_type} onChange={(v) => set("course_type", v)} options={[["recorded", "Recorded"], ["live", "Live"]]} testid="cf-type" />
        <Field label="Price (₹) *">{inp("price", { type: "number", min: 0 })}</Field>
        <Field label="Discount Price (₹)">{inp("discount_price", { type: "number", min: 0 })}</Field>
        <Pick label="Level" value={f.level} onChange={(v) => set("level", v)} options={[["beginner", "Beginner"], ["intermediate", "Intermediate"], ["advanced", "Advanced"]]} testid="cf-level" />
        <Pick label="Validity" value={f.validity_days} onChange={(v) => set("validity_days", v)} options={[[30, "30 Days"], [90, "90 Days"], [180, "180 Days"], [365, "365 Days"], [36500, "Lifetime"]]} testid="cf-validity" />
        <Field label="Language">{inp("language")}</Field>
        <div />
        <Field label="Start Date">{inp("start_date", { type: "date" })}</Field>
        <Field label="End Date">{inp("end_date", { type: "date" })}</Field>
      </div>
    </div>
  );
}
